import Link from 'next/link';
import * as React from 'react';
import { LogoWithIcon } from 'src/Components/Landing/LogoWithIcon';
import { diContainer } from 'src/dependencyInjection/diContainer';
import { DI_TYPES } from 'src/dependencyInjection/diTypes';
import { IEnvironmentService } from 'src/services/EnvironmentService/IEnvironmentService';
import { cn } from 'src/shadcn/lib/utils';

export interface IRequestAppointmentFooterProps {}

export const RequestAppointmentFooter: React.FunctionComponent<
  IRequestAppointmentFooterProps
> = props => {
  return (
    <div>
      <span className='mt-2 hidden flex-col items-center text-sm font-semibold text-gray-600 print:flex'>
        Powered by ShopSparkify.com
      </span>
      <div className='mb-10 mt-40 flex flex-col items-center print:hidden'>
        <span className='font-semibold text-gray-600'>Powered by</span>
        <Link
          href={
            diContainer
              .get<IEnvironmentService>(DI_TYPES.EnvironmentService)
              .get().productionEndpoint
          }
          target='_blank'
        >
          <LogoWithIcon className={cn('flex h-[40px]')} />
        </Link>
      </div>
    </div>
  );
};
